import React, { useEffect, useState } from "react";
import { useStaticQuery, graphql } from "gatsby";
import PropTypes from "prop-types";
import Header from "./header";
import Footer from "./footer";
import GoogleTagManager from "../components/GoogleTagManager";

function Layout({ children, bgcolor, lang, phone }) {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);
  let className = "main_container";
  return (
    <div className={className} id="middle-section">
      <GoogleTagManager />
      <Header
        siteTitle={data.site.siteMetadata?.title || `Title`}
        bgcolor={bgcolor}
        lang={lang}
        phone={phone}
      />
      {children}
      <Footer phone={phone} />
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};
export default Layout;
